import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { HP_COMPETITOR_ID, OTHER_COMPETITOR_ID } from '../constants'

import { getChangedItemWithUpdatedSellThruAndYoYFields } from './getChangedItemWithUpdatedSellThruAndYoYFields'

interface IGetRecalculatedSellThruAndFYFields {
  competitors: ISobCompetitor[]
  field: string
}

export const getRecalculatedSellThruAndFYFieldsForOthers = ({
  field,
  competitors,
}: IGetRecalculatedSellThruAndFYFields) => {
  return competitors.map((comp) => {
    const hpItem = competitors.find(
      (el) => el.EntryId === comp.EntryId && el.CompetitorID === HP_COMPETITOR_ID
    )
    const fieldValue = comp[field]
    if (comp.CompetitorID === OTHER_COMPETITOR_ID) {
      return getChangedItemWithUpdatedSellThruAndYoYFields({
        field,
        value: fieldValue,
        item: comp,
        hpItem,
      })
    }
    return comp
  }, [])
}
